import * as R from 'ramda'
import { Api } from '../lib'
import ActionType from './action-types'

const node_api = new Api({ node_api: true })

const TYPE = {
  create_order: 'CREATE_ORDER',
  create_order_error: 'CREATE_ORDER_ERROR',
  clear_new_order: 'CLEAR_NEW_ORDER',
  get_all_orders: 'GET_ALL_ORDERS',
  get_last_order: 'GET_LAST_ORDER',
}

const fetchLastOrder = () => dispatch =>
  node_api.get('new_order').then(orders =>
    dispatch({
      type: TYPE.get_last_order,
      payload: orders.data.rows[0],
    })
  )

const fetchAllOrders = () => dispatch =>
  node_api
    .get('new_order')
    .then(orders =>
      dispatch({
        type: TYPE.get_all_orders,
        payload: orders.data,
      })
    )
    .catch(err => dispatch({ type: ActionType.ERR, payload: err }))

const _createBody = params => getState => {
  const body = {
    billing: params.billing,
    customer_note: params.customer_note,
    subscription_discount: params.subscription_discount,
    products: R.map(item => ({
      product_id: item.id,
      variation_id: item.variation.variation_id,
      quantity: item.quantity,
    }))(getState().cart.cart_content),
    shipping: {
      city: params.shipping.city,
      state: params.shipping.state,
      postcode: params.shipping.postcode,
      address_1: params.shipping.address_1,
      address_2: params.shipping.address_2,
    },
  }

  const payment = params.payment_method_token
    ? { payment_method_token: params.payment_method_token }
    : { payment_method_nonce: getState().payment.nonce }

  return R.merge(body, payment)
}

const create = params => (dispatch, getState) =>
  node_api

    .post('new_order', { body: _createBody(params)(getState) })

    .then(response => {
      dispatch({
        type: TYPE.create_order,
        payload: response.data,
      })

      // TODO: Manually add the order in the reducer to avoid extra api hit
      dispatch(fetchAllOrders())

      localStorage.removeItem('products')
      dispatch({ type: ActionType.CLEAR_CART })
    })

    .catch(err => dispatch({ type: ActionType.ERR, payload: err }))

const clearNewOrder = () => dispatch =>
  dispatch({
    type: TYPE.clear_new_order,
  })

export default {
  TYPE,
  create,
  clearNewOrder,
  fetchAllOrders,
  fetchLastOrder,
}
